var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailSent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 145,
    viewBox: "0 0 266 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.44519,
    y: 2.09674,
    width: 225.878,
    height: 140.885,
    rx: 8.49008,
    fill: "white",
    stroke: "#195F55",
    strokeWidth: 3.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.712 78.8804L109.706 78.8756L12.8865 2.09674H215.834L119.014 78.8756L119.008 78.8805C117.682 79.9419 116.044 80.5173 114.36 80.5173C112.676 80.5173 111.038 79.9419 109.712 78.8804Z",
    fill: "white",
    stroke: "#195F55",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M226.211 114.784C246.905 114.784 263.682 98.0081 263.682 77.3136C263.682 56.6191 246.905 39.843 226.211 39.843C205.516 39.843 188.74 56.6191 188.74 77.3136C188.74 98.0081 205.516 114.784 226.211 114.784Z",
    fill: "#D9E3BC",
    stroke: "#195F55",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M247.39 62.6513L221.323 91.9762",
    stroke: "#195F55",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M205.032 78.943L221.323 91.9763",
    stroke: "#195F55",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSent);
export default __webpack_public_path__ + "static/media/email-sent.d58ea0f145dd8d4a6bef2b3f43fe137d.svg";
export { ForwardRef as ReactComponent };